import { render } from "./WidgetBlock.vue?vue&type=template&id=9c20fd9a&ts=true"
import script from "./WidgetBlock.vue?vue&type=script&lang=ts"
export * from "./WidgetBlock.vue?vue&type=script&lang=ts"

import "./WidgetBlock.vue?vue&type=style&index=0&id=9c20fd9a&lang=scss"

import exportComponent from "/home/node/app/.yarn/__virtual__/vue-loader-virtual-2429a647ea/0/cache/vue-loader-npm-17.0.0-6ebaa2d3c5-0c0a647a4e.zip/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__